import { render, staticRenderFns } from "./DiscountCheckboxField.vue?vue&type=template&id=215c2a33&"
import script from "./DiscountCheckboxField.vue?vue&type=script&lang=ts&"
export * from "./DiscountCheckboxField.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCheckboxField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports